import Layout from "../../layout";
import React, {useState, useEffect} from "react";
import {Container, Button, Row, Col, Form} from "react-bootstrap";
import axios from 'axios';
import {useParams, useNavigate} from "react-router-dom";
import ReactQuill from 'react-quill';
import {useForm} from "react-hook-form";
import Swal from "sweetalert2";

function Edit() {
    const [content, setContent] = useState([]);
    const [change, setChange] = useState(0);
    const [loading, setLoading] = useState(true);
    const {register, handleSubmit, reset, setValue} = useForm();
    const [quillValue, setQuillValue] = useState('');
    const {contentId} = useParams();
    const [base64Image, setBase64Image] = useState('');
    const [users, setUsers] = useState([]);
    const [sites, setSites] = useState([]);
    const navigate = useNavigate();


    const modules = {
        toolbar: [
            [{'header': '1'}, {'header': '2'},{'header': '3'},{'header': '4'}, 'blockquote'],
            [{'list': 'ordered'}, {'list': 'bullet'}],
            ['bold', 'italic', 'underline'],
            ['link', 'image'],
            ['clean']
        ],
    };

    const deletePhoto = () => {
        setBase64Image("")
        axios.get(`${process.env.REACT_APP_API_URL}/content/deletePhoto/${contentId}`)
            .then(function (response) {
                if (response.data.status === true) {
                    setChange(change + 1)
                } else {
                    console.log(response);
                    Swal.fire({
                        text: response.data.message,
                        icon: "error",
                        confirmButtonText: "Tamam",
                    });
                }
            });
    }
    const handleImageChange = (event) => {
        const file = event.target.files[0];

        if (file) {
            const reader = new FileReader();

            reader.onload = (e) => {
                const base64String = e.target.result;
                setBase64Image(base64String);
            };

            reader.readAsDataURL(file); // Resmi Base64'e çevir
        }
    }
    const getContent = async ()  =>{
        await axios.get(`${process.env.REACT_APP_API_URL}/user`, {page: 1, size: 1000})
            .then(function (response) {
                if (response.data.status === true) {
                    setUsers(response?.data?.data);
                } else {
                    console.log(response);
                }
            });

        await axios.get(`${process.env.REACT_APP_API_URL}/site`, {page: 1, size: 1000})
            .then(function (response) {
                if (response.data.status === true) {
                    setSites(response?.data?.data);
                } else {
                    console.log(response);
                }
            });


        await axios.get(`${process.env.REACT_APP_API_URL}/content/${contentId}`)
            .then(function (response) {
                console.log(response);
                if (response.data.status === true) {
                    reset(response.data.data);
                    setContent(response.data.data);
                    setQuillValue(response.data.data?.contentText);
                    document.title = response.data.data.contentTitle;
                    setLoading(false);
                } else {
                    console.log(response);
                    if(response?.data?.code == 403){
                        navigate("/home");
                    }
                }
            });
    }

    useEffect(() => {
        getContent();
    }, [change]);

    const handleQuillChange = (html) => {
        setValue('contentText', html);
    };

    const onSubmit = async (data) => {
        try {
            if (base64Image) {
                data["contentPhoto"] = base64Image;
            }

            await axios.post(`${process.env.REACT_APP_API_URL}/content/update/${contentId}`, data)
                .then(function (response) {
                    console.log(response);
                    if (response.data.status === true) {
                        Swal.fire({
                            text: "İşlem başarıyla tamamlandı.",
                            icon: "success",
                            confirmButtonText: "Tamam",
                        });
                    } else {
                        console.log(response);
                        Swal.fire({
                            text: response.data.message,
                            icon: "error",
                            confirmButtonText: "Tamam",
                        });
                    }

                });
        } catch (e) {
            console.log(e);
        }
    }

    return (
        <Layout>
            {loading ?
                <img className="loading" src={require("../../../src/images/loading.gif")}/>
                :
                <Form className="d-flex flex-column h-100" method="POST" onSubmit={handleSubmit(onSubmit)}>
                    <div className="bg-white mb-3 border-bottom py-2">
                        <Container className="d-flex justify-content-between align-items-center">
                            <h2 className="mb-0 fs-5">{document.title}</h2>
                            <Button type="submit" className="py-1 px-3">Kaydet</Button>
                        </Container>
                    </div>
                    <Container>

                        <Row className={"gutters"}>
                            <Col xs={12} md={8}>
                                <Form.Group className="mb-3">
                                    <Form.Label className="required">Başlık</Form.Label>
                                    <Form.Control type="text" maxLength={50} {...register("contentTitle")} required/>
                                </Form.Group>
                                <Form.Group className="mb-3">
                                    <Form.Label className="required">İçerik</Form.Label>
                                    <ReactQuill
                                        theme="snow"
                                        name="contentText"
                                        value={quillValue}
                                        onChange={handleQuillChange}
                                        modules={modules}
                                        formats={[
                                            'header',
                                            'list', 'bullet',
                                            'bold', 'italic', 'underline',
                                            'link', 'image', 'blockquote'
                                        ]}
                                    />
                                </Form.Group>

                            </Col>
                            <Col xs={12} md={4}>
                                <Form.Group className="mb-3">
                                    <Form.Label className="required">Durum</Form.Label>
                                    <Form.Select {...register("contentStatus")} required>
                                        {localStorage.getItem('userRole') > 0 && <option value="0">Boşta</option>}
                                        <option value="1">Taslak</option>
                                        <option value="2">Onaya Gönder</option>
                                        {localStorage.getItem('userRole') > 0 && <option value="3">Yayınlandı</option>}
                                        {localStorage.getItem('userRole') > 0 && <option value="4">Gizli</option>}
                                    </Form.Select>
                                </Form.Group>

                                {localStorage.getItem('userRole') > 0 &&
                                    <>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Editör</Form.Label>
                                            <Form.Select {...register("contentEditorId")}>
                                                <option value="">Seçiniz</option>
                                                {
                                                    users != null ?
                                                        users.map(item => (
                                                            <option key={item.userId}
                                                                    value={item.userId}>{item.userName}</option>
                                                        ))
                                                        : null
                                                }

                                            </Form.Select>
                                        </Form.Group>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Site</Form.Label>
                                            <Form.Select {...register("contentSiteId")}>
                                                <option value="">Seçiniz</option>
                                                {
                                                    sites != null ?
                                                        sites.map(item => (
                                                            <option key={item.siteId}
                                                                    value={item.siteId}>{item.siteName}</option>
                                                        ))
                                                        : null
                                                }
                                            </Form.Select>
                                        </Form.Group>


                                        <Row>
                                            <Col xs={12} md={6}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Fiyat (TL)</Form.Label>
                                                    <Form.Control type="number" maxLength={50} min={0} {...register("contentPrice")}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col xs={12} md={6}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Kelime Sayısı</Form.Label>
                                                    <Form.Control type="number" maxLength={50} min={0}
                                                                  {...register("contentWordCount")} />
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                    </>

                                }

                                <Form.Group className="mb-3">
                                    <Form.Label className="required">Öne Çıkarılmış Görsel</Form.Label>
                                    <Form.Control type="file" onChange={handleImageChange}/>
                                    <Form.Control type="hidden"
                                                  defaultValue={content?.contentPhoto} {...register("contentPhoto")}/>

                                    {base64Image && (
                                        <img className={"w-100 border mt-2 rounded bg-white"} src={base64Image}
                                             alt="Base64 Resim"/>
                                    )}
                                    {base64Image?.length == 0 && content?.contentPhoto ? (
                                        <img className={"w-100 border mt-2 rounded bg-white"}
                                             src={content?.contentPhoto}
                                             alt="Base64 Resim"/>
                                    ) : null}

                                    {base64Image || content?.contentPhoto ?
                                        <Button variant="link"
                                                className="w-100 mt-2 text-decoration-none p-0 text-start text-danger w-auto"
                                                size="sm" onClick={deletePhoto}>öne çıkarılmış görseli kaldır.</Button>
                                        :
                                        null}

                                    <Form.Group className="mb-3 mt-4">
                                        <Form.Label>Resim Kaynağı</Form.Label>
                                        <Form.Control type="text" maxLength={50} {...register("contentPhotoSource")}/>
                                    </Form.Group>
                                    <Form.Group className="mb-3 mt-4">
                                        <Form.Label>İçerik Kaynağı</Form.Label>
                                        <Form.Control type="text" maxLength={50} {...register("contentSource")}/>
                                    </Form.Group>

                                    {localStorage.getItem('userRole') > 0 ?
                                        <Form.Group className="mb-3">
                                            <Form.Label>İçerik Hakkında</Form.Label>
                                            <Form.Control as={"textarea"} maxLength={200} {...register("contentTerms")}/>
                                        </Form.Group>
                                        :
                                        content?.contentTerms &&
                                        <Form.Group className="mb-3">
                                            <Form.Label>İçerik Hakkında</Form.Label>
                                            <small className={"d-block"}>{content?.contentTerms}</small>
                                        </Form.Group>
                                    }

                                    <a className={"me-2"} target={"_blank"} href={process.env.REACT_APP_API_URL + "/content/html/" + contentId}>HTML</a>
                                    <a className={"me-2"} target={"_blank"} href={process.env.REACT_APP_API_URL + "/content/txt/" + contentId}>TXT</a>
                                    <a target={"_blank"} href={process.env.REACT_APP_API_URL + "/content/docs/" + contentId}>ODT</a>

                                </Form.Group>

                            </Col>
                        </Row>
                    </Container>

                </Form>
            }
        </Layout>
    );
}

export default Edit;


